export default function revokeUrls(urls = []) {
    for (const url of urls) {
        URL.revokeObjectURL(url);
    }
}
